
export const OPERATION_MODE_CODES = {
    CLASSIFICATION: 'classification',
    SORTER: 'sorter',
} as const


